import Icon from '../../ui/Icon/Icon';
import styles from './OAuthButton.module.css';

const ICON_NAMES = {
  google: 'Chrome',
  github: 'Github',
};

const LABELS = {
  google: 'auth via google',
  github: 'auth via github',
};

// Social login button — brutalist style, lucide icons.
export default function OAuthButton({ provider, onClick }) {
  return (
    <button type="button" className={styles.button} onClick={() => onClick(provider)}>
      <span className={styles.icon}>
        <Icon name={ICON_NAMES[provider]} size={18} />
      </span>
      <span className={styles.label}>{LABELS[provider]}</span>
      <span className={styles.arrow}>
        <Icon name="ArrowRight" size={16} />
      </span>
    </button>
  );
}
